

<nav class="navbar siteHeader navbar-expand-lg" [ngClass]="IsLogin === true?'DashboardStaffing selector':''">
    <a class="navbar-brand" href="#"><img [src]="logoPath" alt="" class="img-fluid">Symvasy</a>

    <!-- header.component.html -->
    <div class="navMenu ml-auto" *ngIf="!IsLogin" >
        <div class="navigation" [ngClass]=" IsCollapsedMenu ? 'openlist' : 'closlist'">
            <ul class="navbar-nav">
                <li *ngFor="let menu of HeaderData" class="nav-item" (click)="activeLinks(menu.label)"
                    [ngClass]="LinkActive === menu.label ? 'active' : ''">
                    <a class="nav-link" *ngIf="menu.label.toLowerCase() != 'login' && showRegisterLink && menu.label=='Register'"
                     (click)="redirectTo(menu.links[0].action)">{{ menu.label }}</a>
                </li>
                <!-- [routerLink]="menu.links.length > 0 ? menu.links[0].action : '.'" -->
            </ul>
            <!-- <ul class="navbar-right" *ngIf="HeaderData && HeaderData.length > 0 && HeaderData[HeaderData.length - 1]?.label?.toLowerCase() == 'login'">
                <li class="nav-btn">
                    <a class="btn btn-red" (click)="toggleCollapse()">
                        <span class="icon"><i class="fas fa-user-tie"></i></span>
                        {{ LoginTypeSelect }}<span class="caret"></span>
                    </a>
                    <ul class="drope_downmenu_wrap dropdown" *ngIf="!IsCollapsed">
                        <li *ngFor="let link of HeaderData.slice(-1)[0].links" (click)="selectLoginType(link.action)">
                            <a>{{ link.label }}</a>
                        </li>
                    </ul>
                </li>
            </ul> -->
            <ul class="navbar-right" *ngIf="showLoginButton">
                <li class="nav-btn">
                    <a class="btn btn-red" [routerLink]="['/auth/login/supplier']">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        Login
                    </a>
                </li>
            </ul>
        </div>
    </div>


    <div *ngIf="IsLogin" class="ml-auto">
        <div class="navigation">
            <ul class="navbar-right">
              <li>
                <div class="selectedClient" *ngIf="selectedClientId">
                  <div class="clientname" *ngIf="selectedClientName != ''">
                    <label>Selected Client:</label> {{selectedClientName}}
                  </div>
                  <a class="menu-links" class="text-primary" (click)="exitClientMode()"><i
                    class="fa fa-door-open text-primary"></i>&nbsp;Change Client</a>
                </div>
                <div class="selectedClient" *ngIf="selectedSClientId">
                    <div class="clientname" *ngIf="selectedClientName != ''">
                      <label>Selected Client:</label> {{selectedClientName}}
                    </div>
                    <a class="menu-links" class="text-primary" (click)="exitSClientMode()"><i
                      class="fa fa-door-open text-primary"></i>&nbsp;Change Client</a>
                  </div>
              </li>
                <li class="nav-notification">
                    <a href="javascript:void(0)" class="nav-link" (click)="OpenlfMenu()"><span
                            class="count">0</span><i class="far fa-bell"></i></a>
                </li>
                <li class="nav-profile" (click)="activeLinks('epAnnounce')"
                    [ngClass]="LinkActive=='epAnnounce'?'active':''">
                    <a class="nav-link" *ngIf="UserDataShow"  (click)="toggleMenu()" >
                        <span class="img">
                            <img [src]="(ImgPath == null || ImgPath == '' )? '/assets/images/user.svg' : ImgPath" />
                        </span>
                        <h5 id="ep_profilename" class="marginZero">{{UserName}}&nbsp;
                        </h5>
                    </a>
                    <div *ngIf="OpenMenu">
                        <div class="user-dropdown">
                            <ul class="dropdown">
                                <!-- [routerLink]="(userData?.data.credentials.userType == 'EP')?['/supplier/profile']:['/ep/enterprise/updateprofile']" -->
                                <li *ngIf="UserType != uType.Admin"><a class="menu-links" appHasPermission="Permissions.Profiles.View"  (click)="redirectToProfile();"
                                        id="ep_myprofile"><i class="fa fa-user" ></i>&nbsp;My Profile</a></li>
                                <li><a class="menu-links" appHasPermission="Permissions.Profiles.ChangePassword" (click)="redirectToChangePassword();"
                                    id="ep_myprofile"><i class="fa fa-user" ></i>&nbsp;Change Password</a></li>
                                <li><a class="menu-links" (click)="logout()"><i
                                            class="fa fa-power-off text-danger"></i>&nbsp;Logout</a></li>
                            </ul>
                        </div>
                    </div>

                </li>
            </ul>

        </div>
        <!-- after login header close -->
    </div>

</nav>

<!-- Notification Panel -->
<div class="notificationPanel" [ngClass]=" Islstopen ? 'panel-on' : 'panel-off'">
    <div (click)="OpenlfMenu()" class="panelClose"><i class="material-icons">close</i></div>
    <mat-tab-group>
        <mat-tab>
            <ng-template mat-tab-label>
                Notification
            </ng-template>
            <ng-template matTabContent>
            </ng-template>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                Recent Activities
            </ng-template>
            <ng-template matTabContent>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
